import React from 'react'
import '../Styles/FamilyCampPage2.scss';
import speakerImage1 from "../Images/140311_Stump,_Grant_U3.png";
import speakerImage2 from "../Images/144160____Patton,_Isaac_U_(1).png";

function FamilyCampPage2() {
   return(
      <div className="familyCampPage2Content">
         <div className="familyCampPage2Container">
            <div className="familyCampPage2Title">
                  2023 Family Camp Speakers
            </div>
            <div className="familyCampPage2SpeakerPictures">
               <div className="familyPictureAndText1">
                  <div className='speakerPicture1'>
                     <img className="familyPic1" src={speakerImage1} alt="SpeakerImage1"></img>
                  </div>
                  <div className="speakerName1">
                     Week 1 <br></br>
                     Grant Stump
                  </div>
               </div>

               <div className="familyLineContainer">
                  <div className="famvl"></div>
               </div>
               
               <div className="familyPictureAndText2">
                  <div className='speakerPicture2'>
                     < img className="familyPic2" src={speakerImage2} alt="SpeakerImage2"></img>
                  </div>
                  <div className="speakerName2">
                     Week 2 <br></br>
                     Isaac Patton
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}
export default FamilyCampPage2;
